@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.info {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 16px;
  border-radius: 8px;
  font-family: v.$primary-font;
  @include t.text(16px, 26px, 400);

  strong {
    font-weight: 600;
  }

  &.success {
    background-color: v.$palette-cucumber-10;
    color: v.$palette-cucumber-80;
    box-shadow: v.$shadow2;
  }

  &.error {
    background-color: v.$color-error-10;
    color: v.$color-error;
  }
}

.icon {
  flex-shrink: 0;
}

.content {
  flex: 1;
  min-width: 0;
}

.closeBtn {
  flex-shrink: 0;
}
